import { Row, Col, Card, Collapse, message, Modal, Button, Select, Radio, DatePicker } from 'antd';
import { Document, PDFDownloadLink } from '@react-pdf/renderer';
import { useState, useEffect } from 'react';
import { map as _map, reduce as _reduce } from 'lodash';
import moment from 'moment';
import { useParams } from 'react-router';
import { MONTHS, PAYMENT_PRODUCT_TYPE } from '../../../../constants/AppConstants';
import LoaderComponent from '../../../Loader';
import SilaPaymentModal from '../SilaPaymentModal';
import RefundModal from '../RefundModal';

const { Panel } = Collapse;
const { Option } = Select;

export default function LoanActions({
    showChangeDueDateModal,
    closeDueDateModal,
    closeChargeSilaModal,
    closeRefundModal,
    closeModal,
    modalVisible,
    currentLoanId,
    modalLoading,
    showToggleAutoRenewModal,
    closeToggleAutoRenewModal,
    updatedAutoRenew,
    onToggleAutoRenew,
    toggleAutoRenew,
    updatedDueDate,
    onDueDateValueChange,
    changeDueDate,
    currentData,
    refreshList,
    closeAccount,
    userId,
    stripeCards,
    chargeSilaModalVisible,
    refundModalVisible
}) {
  return (
    <>
      <Modal
        title={'Confirmation'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        visible={modalVisible}
        onOk={closeAccount}
        onCancel={closeModal}
        className="confirm-modal"
      ><>
          <p>Are you sure you want to Close this Account?</p>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>


      <SilaPaymentModal
        refreshList={refreshList}
        silaModalVisible={chargeSilaModalVisible}
        closeSilaModal={closeChargeSilaModal}
        userId={userId}
        productId={currentLoanId}
        paymentProductType={PAYMENT_PRODUCT_TYPE.LOAN}
      />

      <Modal
        title={'Change Due Day'}
        centered
        mask={true}
        maskClosable={true}
        okText={'Update'}
        destroyOnClose={true}
        okButtonProps={{
          disabled: !updatedDueDate
        }}
        closable={true}
        visible={showChangeDueDateModal}
        onOk={changeDueDate}
        onCancel={closeDueDateModal}
        className="confirm-modal"
      >
        <p>Please provide the new Due Date.</p>
        {!modalLoading && <Select placeholder={"Please select new Due Date"}
          onSelect={onDueDateValueChange}
          style={{ minWidth: 200 }}>
          {MONTHS && MONTHS.map((_month) => {
            return <Option key={_month} value={_month}>{_month}</Option>
          })}
        </Select>}
        {modalLoading && <LoaderComponent tip={'Updating Due Date'} />}
      </Modal>

      <RefundModal
        refundModalVisible={refundModalVisible}
        closeRefundModal={closeRefundModal}
        data={currentData}
        userId={userId}
        refetchUserData={refreshList}
        referenceId={currentData?.sbLoanEntry?.id}
        paymentProductType={PAYMENT_PRODUCT_TYPE.SAVINGS_BUILDER}
        showCheckbox={true}
      />

      <Modal
          title={'Toggle Auto Renew'}
          centered
          mask={true}
          maskClosable={true}
          okText={'Update'}
          destroyOnClose={true}
          okButtonProps={{
            disabled: updatedAutoRenew === undefined || updatedAutoRenew === null
          }}
          closable={true}
          visible={showToggleAutoRenewModal}
          onOk={toggleAutoRenew}
          onCancel={closeToggleAutoRenewModal}
          className="confirm-modal"
      >
        <p>Please select whether to enable or disable auto renew</p>
        {!modalLoading &&
            <Radio.Group onChange={onToggleAutoRenew} value={updatedAutoRenew}>
              <Radio value={true}>Enable</Radio>
              <Radio value={false}>Disable</Radio>
            </Radio.Group>
        }
        {modalLoading && <LoaderComponent tip={'Updating Due Date'} />}
      </Modal>
    </>
  );
}